import { Injectable } from '@angular/core';
import { BaseWrapperService } from '../../shared/base-service/base-wrapper.service';
import { VehicleOwnershipSoldNoticeModel } from '../models/vehicle-ownership-sold-notice.model';

@Injectable()
export class SoldNoticeService extends BaseWrapperService {
    getOwnershipsByVehicleId = (vehicleId: number) => this.get('TitleRegistration/SoldNotice/Ownerships/Vehicle/' + vehicleId);
    createSoldNotice = (vehicleOwnershipSoldNotice: VehicleOwnershipSoldNoticeModel) => this.post('TitleRegistration/SoldNotice/CreateSoldNotice/', vehicleOwnershipSoldNotice);

    removeSoldNotice = (vehicleOwnershipId: number) => this.post('TitleRegistration/SoldNotice/Remove/' + vehicleOwnershipId, null);
}
